import { Grid, GridItem, Text } from '@chakra-ui/react';
import React from 'react';

import { ValleyBankCustomerWithRelationships } from '@finley-technologies/valley-bank-utils';

type CustomerInfoCellProps = { label: string; value: React.ReactNode };
const CustomerInfoCell = ({ label, value }: CustomerInfoCellProps) => {
  return (
    <Grid templateRows="repeat(3, 1fr)" w="100%" h="100%">
      <GridItem borderBottom="1px" borderColor="gray.200">
        <Text fontSize="14px" color="black.70">
          {label}
        </Text>
      </GridItem>
      <GridItem gridRow="2/-1">
        {typeof value === 'string' ? (
          <Text fontSize="16px">{value ?? '-'}</Text>
        ) : (
          value
        )}
      </GridItem>
    </Grid>
  );
};

type CustomerInfoProps = { customer: ValleyBankCustomerWithRelationships };
export const CustomerInfo = ({ customer }: CustomerInfoProps) => {
  return (
    <Grid
      templateColumns="repeat(5, 1fr)"
      w="100%"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="8px"
      padding="24px"
    >
      {/* ROW 1 */}
      <GridItem>
        <CustomerInfoCell label="CIF Number" value={customer?.cif_num} />
      </GridItem>
      <GridItem>
        <CustomerInfoCell label="Full Name" value={customer?.full_name} />
      </GridItem>
      <GridItem>
        <CustomerInfoCell label="Bank Number" value={customer?.bank_num} />
      </GridItem>
      <GridItem>
        <CustomerInfoCell label="Branch Code" value={customer?.branch_code} />
      </GridItem>
      <GridItem>
        <CustomerInfoCell label="Officer" value={customer?.officer || '-'} />
      </GridItem>

      {/* ROW 2 */}
      <GridItem>
        <CustomerInfoCell
          label="Customer Since"
          value={customer?.customer_since}
        />
      </GridItem>
      <GridItem>
        <CustomerInfoCell label="Naicis Code" value={customer?.naics_code} />
      </GridItem>
      <GridItem>
        <CustomerInfoCell
          label="Address"
          value={`${customer?.address_1 || '-'}, ${customer?.city || '-'}, ${
            customer?.state || '-'
          }, ${customer?.zip_code || '-'}`}
        />
      </GridItem>
      <GridItem>
        <CustomerInfoCell
          label="Customer Risk Rating"
          value={customer?.ci_risk_rt}
        />
      </GridItem>
      <GridItem>
        <CustomerInfoCell
          label="Customer Prospect Code"
          value={customer?.prospcd}
        />
      </GridItem>
    </Grid>
  );
};
